export class FixedQueue<T>{

  private size: number;

  private cleanUpFunction: (value: T, index: number, obj: T[]) => boolean;

  private storage = [];

  constructor(size:number,
              cleanUpFunction?: (value: T, index: number, obj: T[]) => boolean) {
    this.size = size;
    this.cleanUpFunction = cleanUpFunction;
  }

  public clean(){
    if (this.cleanUpFunction) {
      this.storage.filter(this.cleanUpFunction).forEach((value, index) => {
        this.storage.slice(index);
      });
    }
  }

  public find(predicate: (value: T, index: number, obj: T[]) => boolean, thisArg?: any): T | undefined{
    return this.storage.find(predicate);
  }

  public push(...items: T[]): number {
    if (this.storage.length>=this.size){
      this.prepareSpace(items);
    }
    return this.storage.push(...items);
  }

  private prepareSpace(items: T[]) {
    if (items && items.length>0){
      items.forEach(this.storage.shift);
    }
  }
}
